import { Col, Menu, Row, Skeleton } from "antd";
import { GitBranch, Cloud, Container, MessageSquare } from "lucide-react";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useNavigate, useParams } from "react-router";
import PageContentWrapper from "../../components/PageContentWrapper";
import { PageHeader } from "@ant-design/pro-layout";
import { useRecoilValue } from "recoil";
import { currentProjectState } from "../../recoil/project";
import { useCurrentProject } from "../../contexts/Project";

export default function ProjectIntegrationsRoot() {
    const navigate = useNavigate();
    const location = useLocation();
    const currentProject = useRecoilValue(currentProjectState);
    const [activeTab, setActiveTab] = useState("git");
    const { projectId } = useParams();
    const { updateCurrentProject } = useCurrentProject();
    // The connect modals read the stored project, so they wait for it to match the URL
    const ready = !!projectId && currentProject?.id === projectId;

    useEffect(() => {
        if (projectId && currentProject?.id !== projectId) updateCurrentProject(projectId);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [projectId, currentProject?.id]);

    useEffect(() => {
        setActiveTab(location.pathname.split("/")[4] || "git");
    }, [location.pathname]);

    return (
        <PageContentWrapper
            size="large"
            header={
                <PageHeader
                    title="Integrations"
                />
            }
        >
            <Row gutter={24}>
                <Col span={6}>
                    <Menu
                        mode="inline"
                        className="ant-card-bordered"
                        selectedKeys={[activeTab]}
                        onSelect={(item) => {
                            navigate(item.key);
                            setActiveTab(item.key);
                        }}
                        items={[
                            {
                                key: "git",
                                label: "Git",
                                icon: <GitBranch size={16} />
                            },
                            {
                                key: "cloud",
                                label: "Cloud Accounts",
                                icon: <Cloud size={16} />
                            },
                            {
                                key: "container",
                                label: "Container Registries",
                                icon: <Container size={16} />
                            },
                            {
                                key: "slack",
                                label: "Slack",
                                icon: <MessageSquare size={16} />
                            }
                        ]}
                    />
                </Col>
                <Col span={18}>
                    {ready
                        ? <Outlet key={projectId} context={{ projectDetails: currentProject }} />
                        : <Skeleton active paragraph={{ rows: 6 }} />}
                </Col>
            </Row >
        </PageContentWrapper>
    )
}